export const pageRoutes = [
  { url: '/', pageName: 'dashboard_page' },
  { url: '/account/profile', pageName: 'account_profile_page' },
  { url: '/account/settings', pageName: 'account_settings_page' },
  { url: '/account/personal-data', pageName: 'account_personal_data_page' },
  { url: '/account/info', pageName: 'account_info_page' },
  { url: '/account/finalize-password-recovery/:id', pageName: 'finalize_password_recovery_page' },
  { url: '/account/activate-user/:id', pageName: 'activate_user_page' },
  { url: '/products/:slug/pd/:id', pageName: 'product_details_page' },
  { url: '/products*', pageName: 'products_page' },
  { url: '/promotions', pageName: 'promotions_page' },
  { url: '/checkout', pageName: 'checkout_page' },
  { url: '/checkout/success', pageName: 'checkout_success_page' },
  { url: '/orders', pageName: 'orders_page' },
  { url: '/orders/reserved-products', pageName: 'orders_reserved_products_page' },
  { url: '/orders/:id', pageName: 'order_details_page' },
  { url: '/lists', pageName: 'wishlists_page' },
  { url: '/lists/:id', pageName: 'wishlist_page' },
  { url: '/lists/stock-alert-list', pageName: 'wishlist_stock_alerts_page' },
  { url: '/reports/invoices', pageName: 'reports_invoices_page' },
  { url: '/reports/unpaid-invoices', pageName: 'reports_unpaid_invoices_page' },
  { url: '/reports/balance', pageName: 'reports_balance_page' },
  { url: '/reports/payments', pageName: 'reports_payments_page' },
  { url: '/reports/account-statements', pageName: 'reports_account_statements_page' },
  { url: '/service/rma', pageName: 'rma_page' },
  { url: '/service/warranties', pageName: 'warranties_page' },
  { url: '/addresses', pageName: 'addresses_page' },
  { url: '/users', pageName: 'users_page' },
  { url: '/api-integrations/feeds', pageName: 'api_integration_feeds_page' },
  { url: '/api-integrations/api-information', pageName: 'api_integration_api_information_page' },
  { url: '/api-integrations/ecommerce-tools', pageName: 'api_integration_ecommerce_tools_page' },
  { url: '/information/:id', pageName: 'information_page' },
  { url: '/mfa', pageName: 'mfa_page' },
  { url: '/login', pageName: 'login_page' },
  { url: '/registration', pageName: 'registration_page' },
  { url: '/not-found', pageName: 'not_found_page' },
];

const pathToRegex = path => new RegExp(
  `^${path
    .replace(/:[^/]+/g, '[^/]+')
    .replace(/\//g, '\\/')
    .replace(/\*/g, '.*')}/?$`
);

export const getPageNameFromUrl = url => {
  const pathname = url.split('?')[0].split('#')[0];
  const matched = pageRoutes.find(({ url: pattern }) => pathToRegex(pattern).test(pathname));
  return matched?.pageName ?? 'unknown_page';
};
